var map = {
	"./historia/page-background--dnd--historia.png": 3783,
	"./historia/page-background--pio--historia.png": 6953,
	"./historia/page-background--score--historia.png": 5243,
	"./historia/page-background--select--historia.png": 3307,
	"./historia/page-background--start--historia.png": 4473,
	"./historia/page-background--tf--historia.png": 5809,
	"./kultura/page-background--dnd--kultura.png": 6647,
	"./kultura/page-background--pio--kultura.png": 2057,
	"./kultura/page-background--score--kultura.png": 6671,
	"./kultura/page-background--select--kultura.png": 9317,
	"./kultura/page-background--start--kultura.png": 5397,
	"./kultura/page-background--tf--kultura.png": 9547,
	"./motoryzacja/page-background--dnd--motoryzacja.png": 9715,
	"./motoryzacja/page-background--pio--motoryzacja.png": 77,
	"./motoryzacja/page-background--score--motoryzacja.png": 8595,
	"./motoryzacja/page-background--select--motoryzacja.png": 6079,
	"./motoryzacja/page-background--start--motoryzacja.png": 6025,
	"./motoryzacja/page-background--tf--motoryzacja.png": 1857,
	"./programowanie/page-background--dnd--programowanie.png": 363,
	"./programowanie/page-background--menu--programowanie.png": 8036,
	"./programowanie/page-background--pio--programowanie.png": 9889,
	"./programowanie/page-background--score--programowanie.png": 6579,
	"./programowanie/page-background--select--programowanie.png": 7535,
	"./programowanie/page-background--start--programowanie.png": 3789,
	"./programowanie/page-background--tf--programowanie.png": 4829,
	"./technologia/page-background--dnd--technologia.png": 667,
	"./technologia/page-background--pio--technologia.png": 1769,
	"./technologia/page-background--score--technologia.png": 7615,
	"./technologia/page-background--select--technologia.png": 7455,
	"./technologia/page-background--start--technologia.png": 1113,
	"./technologia/page-background--tf--technologia.png": 849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9666;